import React from "react";

const MicOn = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 23H19V25C19 26.1046 18.1046 27 17 27V27C15.8954 27 15 26.1046 15 25V23Z"
        fill="#2BC138"
      />
      <path
        d="M11 18C11 24.6667 23 24.6667 23 18"
        stroke="#2BC138"
        strokeWidth="2.5"
      />
      <rect
        id="mic-color-element"
        x="13"
        y="7"
        width="8"
        height="13"
        rx="4"
        fill="#2BC138"
      />
    </svg>
  );
};

export default MicOn;
